import $ from 'jquery';
import './Libraries/LFM/Menu';

$('.navigation__list--level1').menu({desktop: 1340});

var pageScrollTop;

$('.navigation__link--level1.navigation__link--parent').on('click', function (e) {
    e.preventDefault();
    var $siblingPages = $(this).closest('.navigation__page--level1').siblings('.navigation__page');
    $siblingPages.find('.navigation__list-wrap').removeClass('navigation__list-wrap--show');
    $siblingPages.find('.navigation__link').removeClass('navigation__link--active');
    $(this).toggleClass('navigation__link--active');
    $(this).siblings('.navigation__list-wrap').toggleClass('navigation__list-wrap--show');
})

$(document).on('click', function (e) {
    if(!$(e.target).hasClass('navigation') &&
        $(e.target).closest('.navigation').length < 1
    ) {
        $('.navigation__list-wrap').removeClass('navigation__list-wrap--show');
        $('.navigation__link').removeClass('navigation__link--active');
    }
})


var pageScrollTop;

$('.nav-toggle').on('click', function() {
    var $page = $('.page');
    if($(this).hasClass('nav-toggle--active')) {
        $page.removeClass('page--blocked');
        $(window).scrollTop(pageScrollTop);
    }
    else {
        pageScrollTop = $(window).scrollTop();
        $page.addClass('page--blocked');
        $page.scrollTop(pageScrollTop);
    }
})
